import { IAuthor } from '@shared/models/author.model';
import { IMovimentacaoAdmissaoFormModel } from '../components/form/movimentacoes-admissoes-form.model';

export enum MovimentacaoAdmissaoSituacao {
    RASCUNHO = 0,
    ENVIADO = 1,
    CONFIRMADO = 2,
    EXCLUIDA = 3,
    ERRO = 4
}

export interface IMovimentacaoAdmissaoResumo {
    movimentacao: string;
    situacao: number;
}

export interface IMovimentacaoAdmissaoSolicitacao {
    solicitacao: string;
    tiposolicitacao: number;
    estabelecimento?: string | { estabelecimento: string };
}

export interface IMovimentacaoAdmissao {
    movimentacaosolicitacao: string;
    solicitacao: IMovimentacaoAdmissaoSolicitacao;
    ordem: number;
    evento: {
        evento: string;
        codigo: string;
        nome: string;
        tipovalor: number;
        unidade: number;
    };
    lotacao: {
        lotacao: string;
        codigo: string;
        nome: string;
    };
    valor: string | number | null;
    referencia: string | null;
    vigencia: 1 | 2 | 3;
    vigenciamesfinal: number | null;
    vigenciaanofinal: number | null;
    situacao: MovimentacaoAdmissaoSituacao;
    movimentacao: IMovimentacaoAdmissaoResumo | null;
    versao: number;
    created_at?: string;
    created_by?: IAuthor;
    updated_at?: string | null;
    updated_by?: IAuthor | null;
}

export interface IMovimentacaoAdmissaoCreatePayload {
    solicitacao: string;
    evento: string;
    lotacao: string;
    valor: string | number;
    referencia: string | null;
    vigencia: 1 | 2 | 3;
    vigenciamesfinal: number | null;
    vigenciaanofinal: number | null;
}

export interface IMovimentacaoAdmissaoUpdatePayload {
    evento: string;
    lotacao: string;
    valor: string | number;
    referencia: string | null;
    vigencia: 1 | 2 | 3;
    vigenciamesfinal: number | null;
    vigenciaanofinal: number | null;
    versao: number;
}

export interface IMovimentacaoAdmissaoCreateResponse {
    movimentacaosolicitacao: string;
}

export interface IMovimentacaoAdmissaoFormModalParams {
    solicitacao: string;
    dataadmissao: string | Date | null;
    lotacao?: {
        lotacao: string;
        codigo: string;
        nome: string;
    } | null;
    movimentacao?: IMovimentacaoAdmissao | null;
}

export interface IMovimentacaoAdmissaoFormModalResult {
    payload: IMovimentacaoAdmissaoCreatePayload | IMovimentacaoAdmissaoUpdatePayload;
    model: IMovimentacaoAdmissaoFormModel;
}
